import {StyleSheet, TextInput, View} from "react-native";
import {Color} from "@/lib/styles";
import {useSession} from "@/lib/auth/auth";
import {Link, router} from "expo-router";
import ActionButton from "@/lib/components/ActionButton";
import {useRef, useState} from "react";
import {LoginRequest, Session} from "@/lib/types";
import Page from "@/lib/pages/Page";
import Center from "@/lib/components/Center";
import {fetchBackend} from "@/lib/backend";
import ErrorMessage from "@/lib/components/ErrorMessage";
import Nav from "@/lib/components/Nav";
import Header from "@/lib/components/Header";
import globstyles from "@/lib/globstyles";
import {KeyboardAwareScrollView} from "react-native-keyboard-controller";

export default function LoginPage() {
    const {session, setSession} = useSession();

    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<Error | null>(null);
    const [busy, setBusy] = useState(false);

    const passwordInput = useRef<TextInput>(null);

    async function loginCallback() {
        const request: LoginRequest = {username, password};
        setBusy(true);
        fetchBackend<Session>("/account/login", "POST", session, request).then(async (session) => {
            setSession(session);
            router.replace('/u');
        }).catch((error) => {
            setError(error);
        }).finally(() => {
            setBusy(false);
        });
    }

    return (
        <Page>
            <Center width={330}>
                <KeyboardAwareScrollView
                    scrollEnabled={false}
                >
                    <View style={{gap: 12}}>
                        <Header title={"Logg inn på Eventlista"}/>

                        <View style={styles.formContainer}>
                            <TextInput style={globstyles.formTextInput}
                                       placeholder={"Brukernavn eller e-post"}
                                       placeholderTextColor={Color.FadedText}
                                       value={username}
                                       onChangeText={(username) => {
                                           setUsername(username);
                                           setError(null);
                                       }}
                                       autoComplete={"email"}
                                       inputMode={"email"}
                                       returnKeyType={"next"}
                                       enablesReturnKeyAutomatically={true}
                                       focusable={true}
                                       autoFocus={true}
                                       keyboardAppearance={"dark"}
                                       submitBehavior={"submit"}
                                       onSubmitEditing={() => passwordInput.current?.focus()}
                            />

                            <TextInput style={globstyles.formTextInput}
                                       placeholder={"Passord"}
                                       placeholderTextColor={Color.FadedText}
                                       textContentType={"password"}
                                       secureTextEntry={true}
                                       value={password}
                                       onChangeText={(password) => {
                                           setPassword(password);
                                           setError(null);
                                       }}
                                       returnKeyType={"send"}
                                       focusable={true}
                                       enablesReturnKeyAutomatically={true}
                                       ref={passwordInput}
                                       keyboardAppearance={"dark"}
                                       autoComplete={"current-password"}
                                       onSubmitEditing={loginCallback}
                            />

                            {!!error && (<ErrorMessage error={error}/>)}

                        </View>

                        <Nav>
                            <ActionButton title={"Logg inn"} busy={busy} color={Color.Green}
                                          onPress={loginCallback}/>
                        </Nav>
                    </View>

                </KeyboardAwareScrollView>

                <Nav style={{justifyContent: "flex-start", gap: 16}}>
                    <Link style={styles.link} href={`/u/account/create`}>Ny bruker</Link>
                    <Link style={styles.link} href={`/u/account/resetpassword`}>Glemt passord?</Link>
                </Nav>

            </Center>
        </Page>
    );
}

export const styles = StyleSheet.create({
    formContainer: {
        width: "100%",
        gap: 8,
        minHeight: 80,
    },
    link: {
        color: Color.PrimaryText,
        textDecorationLine: "underline",
        fontSize: 16,
    }
})